export enum RInstellingAdditionalObjectKey {
	LICENTIES = 'licenties',
	VESTIGING_NAMEN = 'vestigingNamen',
}
